export default __webpack_public_path__ + "static/media/office_desk.552c5b13.svg";